import styled from 'styled-components';

const DivThreadBody = styled.div`
  width: 100%;
  background-color: transparent;
  border: 0;
  color: var(--on-background);
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  padding: 8px 0;
  min-height: 500px;

  [data-placeholder]:empty::before {
    content: attr(data-placeholder);
    color: var(--on-background-grey)
  }
`;

export default DivThreadBody;
